<template>
  <div>
    <v-switch
      v-model="value.eyewitness"
      :label="$t('incidentReports.incidentReportFormLong.eyewitness')"
    ></v-switch>
  </div>
</template>
<script>
export default {
  props: ["value"],
  data: () => ({}),
  methods: {},
};
</script>
